import { useMemo } from 'react';

import { useBookmakersAll } from './useBookmakersAll';

export const useCalculateNumberOfGridCells = (): number => {
  const userHasFavouriteBookmakers = false;

  const numberOfBookmakers = useBookmakersAll().length;

  const value = useMemo(
    () => (userHasFavouriteBookmakers ? numberOfBookmakers + 2 : numberOfBookmakers + 1),
    [numberOfBookmakers, userHasFavouriteBookmakers],
  );
  return value;
};
